// Resolution caps come from the backend (PaymentPlanTimingService) via
// /payment_plan/info as `max_resolution_payment_count`. This module only maps
// the wizard's frequency labels to that map's code keys — no cap numbers live here.

export const RESOLUTION_FREQUENCY_LABEL_TO_CODE_KEY = {
  Weekly: 'pay_frequency_weekly',
  'Bi-Weekly': 'pay_frequency_biweekly',
  'Semi-Monthly': 'pay_frequency_semimonthly',
  Monthly: 'pay_frequency_monthly',
}

/**
 * Max installments for a resolution plan at the given frequency, from the BE map.
 * 0 when no/unknown frequency or the map hasn't loaded yet.
 *
 * @param {object}  args
 * @param {string}  args.frequencyLabel              e.g. 'Weekly', 'Monthly'
 * @param {object} [args.maxResolutionPaymentCount]  BE map keyed by frequency code key
 * @returns {number}
 */
export function resolutionMaxPaymentCount({ frequencyLabel, maxResolutionPaymentCount = {} }) {
  const codeKey = RESOLUTION_FREQUENCY_LABEL_TO_CODE_KEY[frequencyLabel]
  return (codeKey && maxResolutionPaymentCount?.[codeKey]) || 0
}
